<div class="container-fluid">
    <div class="row d-flex justify-content-center vertical-align-middle">
        <div class="col-12 mobile p-0 d-flex">
            <nav class="navbar navbar-dark" style="width: fit-content;margin-left: auto; margin-right: 5px;">
                <button class="navbar-toggler" type="button" (click)="toggleCollapse()">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </nav>
        </div>
    </div>
    <div class="row mobile">
        <div [visible]="visible" class="p-0" cCollapse>
            <c-card class="mt-3 shadow">
                <c-card-body class="pl-0 pr-0">
                    <ul>
                        <li>
                            <a href="#/">Inicio</a>
                        </li>
                        <li>
                            <a href="#/sobre-el-galardon">Sobre el galardón</a>
                        </li>
                        <li>
                            <a href="#/periodos">Años anteriores</a>
                        </li>
                        <li>
                            <a href="#/preguntas-frecuentes">Preguntas frecuentes</a>
                        </li>
                        <li>
                            <a href="#/contacto">Contáctanos</a>
                        </li>
                        <li class="nav-item">
                    <a class="nav-link" href="/assets/docs/Revista_GI_2025.pdf" target="_blank">Revista 20 años</a>
                </li>
                    </ul>
                </c-card-body>
            </c-card>
        </div>
    </div>
</div>